"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logging = void 0;
var logging = require("./logging");
exports.logging = logging;
//# sourceMappingURL=index.js.map